<template>
  <div id="reasonPreview" class="ml-6 mr-6">
    <div class="text-center">
      <h5>Exemplo de Visualização</h5>
    </div>

    <section class="mt-5 mb-5">
      <vs-textarea
          v-if="use_observation"
          name="observation" class="w-full" label="Observações"
      ></vs-textarea>

      <div v-if="reason_options.length > 0">
        <component
            :index="index"
            :items="responses[index]"
            :description="reason_options[index]"
            v-for="(option, index) in options"
            @valueChanged="updateValue"
            :key="index"
            :is="option"
        />
      </div>
      <div v-else class="text-center" >
          Nenhum campo adicionado
      </div>
    </section>
  </div>
</template>

<script>
  import CheckboxField from '@/views/reason-response-fields/Checkbox'
  import CurrencyField from '@/views/reason-response-fields/Currency'
  import DecimalField from '@/views/reason-response-fields/Decimal'
  import BooleanField from '@/views/reason-response-fields/Boolean'
  import SelectField from '@/views/reason-response-fields/Select'
  import RadioField from '@/views/reason-response-fields/Radio'
  import TextField from '@/views/reason-response-fields/Text'
  import IntField from '@/views/reason-response-fields/Int'
  import vSelect from 'vue-select'

  export default {
    name: 'reasons-preview',
    props: ['reason_options', 'use_observation'],
    data(){
      return {
        data: [],
        options:[],
        responses: [],
        reloadTimer: null
      }
    },
    components: {
      CheckboxField,
      CurrencyField,
      DecimalField,
      BooleanField,
      SelectField,
      RadioField,
      TextField,
      IntField,
      vSelect
    },
    watch: {
      'reason_options': {
        handler() { this.resetOptions() }, deep: true
      },
    },
    mounted(){
      this.reloadTimer = setInterval(() => { this.resetOptions() }, 1500);
    },
    beforeDestroy() {
      clearInterval(this.reloadTimer);
    },
    methods: {
      updateValue (index, itemIndex, value) {
        let opts = {
          reason_option_id: this.responses[index][itemIndex].reason_option_id,
          reason_option_item_id: this.responses[index][itemIndex].reason_option_item_id,
          description: this.responses[index][itemIndex].description,
          value: value.toString()
        }

        let list = this.responses[index]
        list.splice(itemIndex, 1, opts)
        this.responses.splice(index, 1, list)
      },
      resetOptions(){
        this.options = []
        this.responses = []

        if (this.reason_options.length === 0) { return }

        this.reason_options.forEach((opt, idx) => {
          let defaultValue = null

          if(!opt){ return; }
          if(!opt.reason_option_kind){ return; }

          if (opt.reason_option_kind.tag === 'text') {
            this.options.push(TextField)
          }

          if (opt.reason_option_kind.tag === 'int') {
            this.options.push(IntField)
            defaultValue = "0"
          }

          if (opt.reason_option_kind.tag === 'currency') {
            this.options.push(CurrencyField)
            defaultValue = "0"
          }

          if (opt.reason_option_kind.tag === 'decimal') {
            this.options.push(DecimalField)
            defaultValue = "0"
          }

          if (opt.reason_option_kind.tag === 'select') {
            this.options.push(SelectField)
          }

          if (opt.reason_option_kind.tag === 'radio') {
            this.options.push(RadioField)
            defaultValue = "false"
          }

          if (opt.reason_option_kind.tag === 'checkbox') {
            this.options.push(CheckboxField)
            defaultValue = "false"
          }

          if (opt.reason_option_kind.tag === 'boolean') {
            this.options.push(BooleanField)
            defaultValue = "false"
          }

          let items = [null]
          if (opt.reason_option_items_attributes && opt.reason_option_items_attributes.length > 0) {
            items = opt.reason_option_items_attributes
          }

          items.forEach((item) => {
            let itemId = null
            let itemDescription = ''

            if (item) {
              itemId = item.id
              itemDescription = item.description
            }

            if (!this.responses[idx]) {
              this.responses[idx] = []
            }

            this.responses[idx].push({
              reason_option_id: opt.id,
              reason_option_item_id: itemId,
              description: itemDescription,
              value: defaultValue
            })
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  #reasonPreview {
    padding: 10px;
    background: #fff;
    border-radius:10px;
    word-wrap: break-word;
    border: 3px dotted rgba(0, 0, 0, 0.2);
    box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);

    input{
      width: 100%;
    }

    .vs-input{
      width: 100%;
    }
  }
</style>